type UserProvider = "efilm" | "vodafone" | "facebook" | "huawei" | "filmin";

type UserType = "front" | "back" | "profile";

export interface AuthUserDTO {
  id: number;
  name?: string;
  username: string;
  color: string;
  image_avatar?: string;
  is_private: boolean;
  confirmed: boolean;
  country_code: string;
  email: string;
  is_god: boolean;
  provider: UserProvider;
  type: UserType;
  is_parental_enabled: boolean;
  background_image?: string;
  biography?: string;
  instagram_username?: string;
  twitter_username?: string;
  imdb_username?: string;
  reviews_count?: number;
  playlists_count?: number;
  followers_count?: number;
  following_count?: number;
}

export class AuthUserModel {
  readonly id: number;
  readonly name?: string;
  readonly username: string;
  readonly color: string;
  readonly imageAvatar?: string;
  readonly isPrivate: boolean;
  readonly confirmed: boolean;
  readonly countryCode: string;
  readonly email: string;
  readonly isGod: boolean;
  readonly provider: UserProvider;
  readonly type: UserType;
  readonly isParentalEnabled: boolean;
  readonly backgroundImage?: string;
  readonly biography?: string;
  readonly instagramUsername?: string;
  readonly twitterUsername?: string;
  readonly imdbUsername?: string;
  readonly reviewsCount?: number;
  readonly playlistsCount?: number;
  readonly followersCount?: number;
  readonly followingCount?: number;
  public pressMediasIds?: number[];

  constructor(authUserDTO: AuthUserDTO) {
    this.id = authUserDTO.id;
    this.name = authUserDTO.name;
    this.username = authUserDTO.username;
    this.color = authUserDTO.color;
    this.imageAvatar = authUserDTO.image_avatar;
    this.isPrivate = authUserDTO.is_private;
    this.confirmed = authUserDTO.confirmed;
    this.countryCode = authUserDTO.country_code;
    this.email = authUserDTO.email;
    this.isGod = authUserDTO.is_god;
    this.provider = authUserDTO.provider;
    this.type = authUserDTO.type;
    this.isParentalEnabled = authUserDTO.is_parental_enabled;
    this.backgroundImage = authUserDTO.background_image;
    this.biography = authUserDTO.biography;
    this.instagramUsername = authUserDTO.instagram_username;
    this.twitterUsername = authUserDTO.twitter_username;
    this.imdbUsername = authUserDTO.imdb_username;
    this.reviewsCount = authUserDTO.reviews_count;
    this.playlistsCount = authUserDTO.playlists_count;
    this.followersCount = authUserDTO.followers_count;
    this.followingCount = authUserDTO.followers_count;
  }

  setPressMediasIds(ids: number[]) {
    this.pressMediasIds = ids;
  }

  toJSON() {
    return { ...this };
  }
}
